import { t } from 'i18next';
import { useState } from 'react';
import {
    Linking,
    TouchableOpacity,
    View,
    ViewStyle,
    Modal
} from 'react-native';
// import FIcon from 'react-native-vector-icons/Feather';
// import { wp } from '../../_app/helpers/dimensions-helper';

import { PHONE_NUMBER, WHATSAPP_CHAT_LINK } from '../../config/setting';
import { ErrorHandlerService } from '../../services/ErrorHandlerService';
import { THEME_COLORS } from '../../theme/constants/themeColors';
import { StyleHelpers } from '../constants/style-helpers';
import { isAndroid, isIOS } from '../helpers';
import { HorizontalLine } from '../views/miscellaneous';
import { COLORS } from '../../config/colors';
import PrimaryButton from './PrimaryButton';
import CText from '../../ui/components/CText';
import CButton from '../../ui/components/CButton';
import IconButtonHighlight from './IconButtonHighlight';
import {
    CallHelpLineIcon,
    CloseIcon,
    SupportGenericIcon,
    SupportPhoneIllustration,
    WhatsappLogo
} from '../../icons';
import { THEME_STYLES } from '../../theme/constants/themeStyles';
import { useRemoteConfig } from '../../org-app-config/hooks';


type Props = {
    styles?: ViewStyle;
    btnContStyles?: ViewStyle;
};
export const WhatsappSupport = (props: Props) => {
    const {
        styles = {},
        btnContStyles = {},
    } = props;
    //Support Popup
    const [modalVisible, setModalVisible] = useState(false);

    const remoteConfig = useRemoteConfig();

    const phoneNumber = remoteConfig?.contact_number || PHONE_NUMBER;
    const whatsappChatLink = remoteConfig?.whatsapp_chat_link || WHATSAPP_CHAT_LINK;

    const handleWhatsappSupport = () => {
        let msg = `I am facing issues`;
        if (isAndroid()) {
            msg = encodeURIComponent(msg);
        }
        Linking.openURL(`${whatsappChatLink}?text=${msg}`)
            .then(() => {
                // pass
            })
            .catch(e => {
                ErrorHandlerService.handleError(e);
                // showToast(`Could not open WhatsApp. Please contact us on this number: ${WHATSAPP_BUSINESS_NUMBER}`, {
                //     type: 'info',
                // });
            });
    };

    return (
        <>
            <IconButtonHighlight
                style={{
                    // left: 5,
                    backgroundColor: COLORS.blue200,
                    marginRight: -10,
                    marginLeft: 10,
                    ...styles,
                }}
                btnContStyles={{
                    // height: 40,
                    // width: 40,
                    backgroundColor: THEME_COLORS.bgColor,
                    ...THEME_STYLES.buttonBorder,
                    // ...btnContStyles,
                }}
                underlayColor={THEME_COLORS.bgSecondary}
                onPress={() => {
                    setModalVisible(true);
                }}
                // icon={(<CloseCircleIcon/>)}
                icon={(
                    <SupportGenericIcon
                        fill={THEME_COLORS.primaryColor}
                        style={{
                            height: 18,
                            width: 18,
                        }}
                    />
                )}
            />

            <Modal
                style={{
                    flex: 1,
                    margin: 0,
                    justifyContent: "flex-end",
                    // position: "relative",
                }}
                visible={modalVisible}
                transparent={true}
            >
                <View
                    style={{
                        flex: 1,
                        justifyContent: "flex-end",
                        backgroundColor: COLORS.trueBlackTint06,
                    }}>
                    <View
                        style={{
                            // justifyContent: 'center',
                            // flex: 1,
                            // justifyContent: "flex-end",
                            // alignSelf: 'flex-end',
                            zIndex: 100,
                            backgroundColor: THEME_COLORS.bgSecondary,
                            borderTopEndRadius: 16,
                            borderTopStartRadius: 16,
                            // padding: 20,
                            paddingTop: 40,
                            paddingBottom: isIOS() ? 40 : 30,
                            paddingLeft: StyleHelpers.pageSpacing.paddingLeft * 1.5,
                            paddingRight: StyleHelpers.pageSpacing.paddingRight * 1.5,
                        }}>
                        <TouchableOpacity
                            style={{
                                position: 'absolute',
                                top: 15,
                                right: 15,
                            }}
                            activeOpacity={0.8}
                            onPress={() => setModalVisible(false)}>
                            <CloseIcon fill={THEME_COLORS.secondaryTextColor}/>
                        </TouchableOpacity>

                        <SupportPhoneIllustration
                            // width={'100%'}
                            // height={}
                            style={{
                                marginLeft: 10,
                            }}
                        />

                        <HorizontalLine
                            style={{
                                backgroundColor: THEME_COLORS.primaryColor,
                                width: '100%',
                                alignSelf: 'center',
                                marginTop: -1,
                                zIndex: -1,
                            }}
                        />

                        <CText
                            semiBold
                            style={{
                                width: '100%',
                                fontSize: 20,
                                fontWeight: '600',
                                marginTop: 32,
                                marginBottom: 8,
                            }}>
                            {t('GetHelpAndSupport')}
                        </CText>

                        <CText
                            style={{
                                width: '100%',
                                color: COLORS.grey400,
                                fontSize: 17,
                                marginBottom: 16,
                                // paddingLeft: 20,
                            }}>
                            {t('FacingIssuesNeedHelp')}
                        </CText>

                        <PrimaryButton
                            style={{ width: '100%' }}
                            underlayColor={THEME_COLORS.primaryLight}
                            buttonStyle={{
                                backgroundColor: THEME_COLORS.primaryColor,
                            }}
                            textStyle={{
                                fontSize: 16,
                                fontWeight: '600',
                            }}
                            icon={() => {
                                return (
                                    <WhatsappLogo
                                        fill={COLORS.whiteColor}
                                        height={22}
                                        width={22}
                                        style={{
                                            marginRight: 10,
                                        }}
                                    />
                                );
                            }}
                            title={t('WhatsappSupport')}
                            onPress={handleWhatsappSupport}
                        />
                        <CButton
                            style={{ width: '100%', paddingTop: 16 }}
                            buttonStyle={{
                                backgroundColor: THEME_COLORS.bgSecondary,
                                borderColor: THEME_COLORS.borderColor,
                                borderWidth: 1,
                                width: '100%',
                            }}
                            icon={() => {
                                return (
                                    <CallHelpLineIcon
                                        height={20}
                                        width={20}
                                        fill={THEME_COLORS.primaryColor}
                                        style={{
                                            marginRight: 10,
                                        }}
                                    />
                                );
                            }}
                            title={t('CallHelpline')}
                            textStyle={{ color: THEME_COLORS.primaryColor }}
                            onPress={() => {
                                Linking.openURL(`tel:${phoneNumber}`);
                            }}
                        />
                    </View>
                </View>
            </Modal>
        </>
    );
};
